import { useMemo } from 'react';
import { useContextSelector } from 'use-context-selector';

import type { DefaultDialogOptions } from '../dialogs/DefaultDialog/DefaultDialog.types';

import { DialogContext } from '../DialogContext';

export const useDialog = () => {
  const openDialog = useContextSelector(DialogContext, (s) => s.openDialog);
  const closeDialog = useContextSelector(DialogContext, (s) => s.closeDialog);

  return useMemo(
    () => ({
      open: (options: DefaultDialogOptions) => openDialog(options),
      close: () => closeDialog(),
    }),
    [openDialog, closeDialog],
  );
};
